"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _redux = require("redux");
var _reactRedux = require("react-redux");
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _assets = require("@mulesoft/exchange-ui-portals-store/lib/domains/assets");
var _images = require("@mulesoft/exchange-ui-portals-store/lib/utils/images");
var _AssetMetadata = _interopRequireDefault(require("./AssetMetadata"));
var _objects = require("../../utils/objects");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var metadataFields = ['name', 'description', 'contactName', 'contactEmail'];
var mapStateToProps = function mapStateToProps(state, _ref) {
  var asset = _ref.asset;
  return {
    canEdit: _assets.selectors.canShowEdition(state, asset),
    isLoading: _assets.selectors.isUpdatingAssetMetadata(state, {
      groupId: asset.groupId,
      assetId: asset.assetId
    })
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
  var updateIconRoot = _ref2.updateIcon,
    deleteIconRoot = _ref2.deleteIcon;
  return {
    onSaveChanges: function () {
      var _onSaveChanges = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee3(assetDetail, fields) {
        var asset, metadata, updateAssetMetadata, updateAssetIcon;
        return _regenerator.default.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              asset = _objectSpread(_objectSpread({}, assetDetail), {}, {
                organizationId: assetDetail.organization.id
              });
              metadata = metadataFields.reduce(function (accum, key) {
                var _fields$key;
                var fieldValue = (_fields$key = fields[key]) === null || _fields$key === void 0 ? void 0 : _fields$key.value;
                var currentFieldValue = asset[key];

                // Value was not changed
                if (fieldValue === undefined) {
                  return accum;
                }

                // Asset name is required
                if (key === 'name' && !fieldValue) {
                  return accum;
                }
                return fieldValue !== currentFieldValue ? _objectSpread(_objectSpread({}, accum), {}, (0, _defineProperty2.default)({}, key, fieldValue)) : accum;
              }, {});
              updateAssetMetadata = /*#__PURE__*/function () {
                var _ref3 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
                  return _regenerator.default.wrap(function (_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if ((0, _objects.isEmpty)(metadata)) {
                          _context.next = 1;
                          break;
                        }
                        _context.next = 1;
                        return dispatch(_assets.actions.updateAssetMetadata({
                          asset: asset,
                          metadata: metadata
                        }));
                      case 1:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function updateAssetMetadata() {
                  return _ref3.apply(this, arguments);
                };
              }();
              updateAssetIcon = /*#__PURE__*/function () {
                var _ref4 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2() {
                  var _fields$icon, _fields$icon2;
                  var iconValue, iconType, icon, _yield$dispatch, externalLink;
                  return _regenerator.default.wrap(function (_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        iconValue = (_fields$icon = fields.icon) === null || _fields$icon === void 0 ? void 0 : _fields$icon.value;
                        iconType = (_fields$icon2 = fields.icon) === null || _fields$icon2 === void 0 ? void 0 : _fields$icon2.type; // Asset icon was uploaded to the asset
                        if (!iconValue) {
                          _context2.next = 2;
                          break;
                        }
                        icon = (0, _images.convertBase64ToBlob)(iconValue, iconType);
                        _context2.next = 1;
                        return dispatch(_assets.actions.updateIcon({
                          asset: asset,
                          icon: icon
                        }));
                      case 1:
                        _yield$dispatch = _context2.sent;
                        externalLink = _yield$dispatch.externalLink;
                        if (!externalLink) {
                          _context2.next = 2;
                          break;
                        }
                        _context2.next = 2;
                        return updateIconRoot(asset, externalLink);
                      case 2:
                        if (!(iconValue === null && !!assetDetail.icon)) {
                          _context2.next = 4;
                          break;
                        }
                        _context2.next = 3;
                        return dispatch(_assets.actions.deleteIcon({
                          asset: asset
                        }));
                      case 3:
                        _context2.next = 4;
                        return deleteIconRoot(asset);
                      case 4:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function updateAssetIcon() {
                  return _ref4.apply(this, arguments);
                };
              }();
              _context3.next = 1;
              return Promise.all([updateAssetMetadata(), updateAssetIcon()]);
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function onSaveChanges(_x, _x2) {
        return _onSaveChanges.apply(this, arguments);
      }
      return onSaveChanges;
    }()
  };
};
var mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, stateProps), dispatchProps), ownProps), {}, {
    onSaveChanges: function onSaveChanges(fields) {
      return dispatchProps.onSaveChanges(ownProps.asset, fields);
    }
  });
};
var mapRootDispatchToProps = function mapRootDispatchToProps(dispatch) {
  return {
    updateIcon: function updateIcon(asset, icon) {
      return dispatch(_assets.actions.updateIconRoot(asset, icon));
    },
    deleteIcon: function deleteIcon(asset) {
      return dispatch(_assets.actions.deleteIconRoot(asset));
    }
  };
};
var ConnectedAssetMetadata = (0, _redux.compose)((0, _reactRedux.connect)(null, mapRootDispatchToProps, null, {
  context: _exchangeReactHooks.RootStoreContext
}), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps))(_AssetMetadata.default);
var _default = exports.default = ConnectedAssetMetadata;
//# sourceMappingURL=AssetMetadata.container.js.map